import { invokeFunction } from '../api'
import { toApiRequestError } from '../errors'

export interface VisitScoreSummary {
  score_id?: string
  overall_score?: number
  grade?: string
  status?: string
  [key: string]: unknown
}

/**
 * POST scoring /visits/:visitId:calculate (#1799).
 * Writes/refreshes the scores row required by reports:draft.
 */
export async function calculateVisitScore(visitId: string): Promise<VisitScoreSummary> {
  const id = String(visitId || '').trim()
  if (!id) {
    throw new Error('visitId is required')
  }

  const { data, error } = await invokeFunction<unknown>('scoring', {
    method: 'POST',
    path: `/visits/${id}:calculate`,
  })

  if (error || !data) {
    throw toApiRequestError(error, 'Failed to calculate visit score')
  }

  return data as VisitScoreSummary
}
